export const MAX_COMMENT_CHARS = 140
export const MIN_COMMENT_CHARS = 30

export const SOCIAL_SECTION_ID = 'social'
export const EVENTS_SECTION_ID = 'events'
